/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ErrorTypes } from '../../enums';

export class BaseInternalError extends Error {

    type: ErrorTypes;

    constructor(message?: string) {
        super(message);

        this.type = ErrorTypes.Internal;
    }
}
